import styled from 'styled-components/macro';

export const Ruler = styled.div<{ disableMargins?: boolean }>`
  margin: ${(props) => (props.disableMargins ? '0' : '8px 0')};
  border-top: 1px solid ${(props) => props.theme.colors.neutral02};
`;
